import { PARTNERPROFILE__MUTATIONS } from "../mutation-types";
import { PARTNERPROFILE__ACTIONS } from '../action-types'
import { PARTNERPROFILE__API } from '@/_helpers/urls'
import http from "@/_helpers/http";

// State
const state = {
    partnerprofile: []
};

// Mutations
const mutations = {
    [PARTNERPROFILE__MUTATIONS.PARTNERPROFILE](state, data) {
        state.partnerprofile = data
    },
};

const getters = {};

// Actions
const actions = {
    async [PARTNERPROFILE__ACTIONS.PARTNERPROFILE]({ commit }, parameter) {
        try {
            const response = await http().get(`${PARTNERPROFILE__API.PARTNERPROFILE}?parent=${parameter?.id || null}`);
            const responseData = response.data?.data;
            commit(PARTNERPROFILE__MUTATIONS.PARTNERPROFILE, responseData);
        } catch (error) {
            console.error("Error fetching partner profile:", error);
        }
    }

};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
